// The bundled offline story: the original "Terminal Sprint" roguelike played
// when no Supabase repository is configured (or as a fallback when a remote
// story fails to load). Colors/messages that used to live in main.ts live
// here now so Game stays story-agnostic.

import storyJson from "@/narrative/story.ink.json";
import { FLOOR_POOL, type FloorNode } from "@/roguelike/floorPool";
import type { PlayableStory } from "./playable";

export const BUILTIN_STORY_ID = "builtin-terminal-sprint";
export const BUILTIN_STORY_TITLE = "The Terminal Sprint";

export const BUILTIN_SCENE_COLORS: Record<string, string> = {
  desk: "#141b33",
  garden: "#0c1e2a",
  auth: "#24203a",
  legacy: "#3a2415",
  tests: "#173a2e",
  database: "#27203a",
  prod: "#3a1a14",
  merge: "#2a2a3a",
  boss: "#3d0f14",
  victory: "#123a2a",
  crash: "#4a000a",
};

export const BUILTIN_ENDING_COLORS: Record<string, string> = {
  shipped: "#123a2a",
  crash: "#4a000a",
  fail: "#5a0000",
};

export const BUILTIN_MESSAGES: Record<string, string> = {
  boot: "SPRINT N+1: COMMENCE",
  ship: "FEATURE SHIPPED",
  game_over: "ENVIRONMENT TERMINATED",
  floor: "FLOOR LOADED",
  boss: "SENIOR DEV AWAITS",
};

export function createBuiltinStory(): PlayableStory {
  return {
    id: BUILTIN_STORY_ID,
    title: BUILTIN_STORY_TITLE,
    schema: "roguelike",
    inkJson: JSON.stringify(storyJson),
    floors: FLOOR_POOL as FloorNode[],
    sceneColors: { ...BUILTIN_SCENE_COLORS, ...BUILTIN_ENDING_COLORS },
    messages: { ...BUILTIN_MESSAGES },
  };
}
